import React, { FC } from 'react';
import {
  CardInfo,
  CardInfoItem,
  CardInfoValueType,
  FlexItem,
  H3,
  Caption,
} from '@erecruit/ui-kit';
import moment from 'moment';
import { Intl } from '@erecruit/core';
import { Resources } from '@erecruit/types';
import { DATE_FORMAT, US_TIME_FORMAT } from '../../../../constants';

const { FormattedMessage } = Intl;

type ScheduleSectionProps = {
  data: Resources.ShiftSchedule;
};

type StartEndTimeProps = {
  start: Date;
  end: Date;
  startDate: string;
  endDate: string;
};

const OvernightShift = () => (
  <Caption inline={true}>
    (<FormattedMessage id={messageIds.vms.shiftRecord.overnightShift} />)
  </Caption>
);

const StartEndTime: FC<StartEndTimeProps> = props => {
  const { start, end, startDate, endDate } = props;
  const startTime = moment(start).format(US_TIME_FORMAT);
  const endTime = moment(end).format(US_TIME_FORMAT);
  const sameDay = moment(startDate).isSame(endDate, 'day');

  return (
    <>
      <H3>
        {startTime} - {endTime} {!sameDay && <OvernightShift />}
      </H3>
    </>
  );
};

const ScheduleSection: FC<ScheduleSectionProps> = props => {
  const { start, end } = props.data;
  const startDate = moment(start).format(DATE_FORMAT);
  const endDate = moment(end).format(DATE_FORMAT);

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage id={messageIds.vms.shiftRecord.schedule.title} />
          </H3>
        }
        config={{ dateFormat: DATE_FORMAT }}
      >
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.schedule.startEndTime}
            />
          }
          type={CardInfoValueType.Custom}
          value={
            <StartEndTime
              start={start}
              end={end}
              startDate={startDate}
              endDate={endDate}
            />
          }
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.schedule.startDate}
            />
          }
          type={CardInfoValueType.Text}
          value={startDate}
        />
        <CardInfoItem
          label={
            <FormattedMessage
              id={messageIds.vms.shiftRecord.schedule.endDate}
            />
          }
          type={CardInfoValueType.Text}
          value={endDate}
        />
      </CardInfo>
    </FlexItem>
  );
};

export default ScheduleSection;
